module.exports = __webpack_public_path__ + "static/collectorcans-jd-artwork-9656f5d23d115ab9f6c0694070f61866.png";